import React from 'react';

import {Card} from '../../../components/Card/Card';

import cls from './HowToUse.module.scss'

export const HowToUse = () => (
    <div className={cls.block}>
        <h2>Как воспользоваться</h2>
        <div className={cls.cards}>
            <Card bottom={
                <div>Подключите услугу и&nbsp;установите приложение Vita в&nbsp;<a href={'https://apps.apple.com/app/vita/id6744920674'} target={'_blank'} rel={'noreferrer'}>App&nbsp;Store</a> или <a href={'https://play.google.com/store/apps/details?id=space.aevitas.app'} target={'_blank'} rel={'noreferrer'}>Google&nbsp;Play</a>
                    </div>
            }><h2>Шаг&nbsp;1</h2></Card>
            <Card bottom={
                    <div>Войдите в&nbsp;приложение с&nbsp;вашим номером t2 и&nbsp;составьте профиль здоровья, заполнив данные в&nbsp;приложение
                    </div>
            }><h2>Шаг&nbsp;2</h2></Card>
            <Card bottom={
                    <div>Получите консультацию нутрициолога, заполнив заявку на&nbsp;сайте<br/>
                        <a href={'https://fintechservice.group/consultation'} target={'_blank'} rel={'noreferrer'}>https://fintechservice.group/consultation</a>
                    </div>
            }><h2>Шаг&nbsp;3</h2></Card>
        </div>
    </div>
)